/**
 * @generated SignedSource<<1917bacfa9d68325478cb922c62d550e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */
'use strict';

var node = function () {
  var v0 = [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "logoUploadUrl",
    "storageKey": null
  }];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "logoUploadUrlQuery",
      "selections": v0
      /*: any*/
      ,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "logoUploadUrlQuery",
      "selections": v0
      /*: any*/

    },
    "params": {
      "cacheID": "b6212bbf4962e105a88b78e102871d90",
      "id": null,
      "metadata": {},
      "name": "logoUploadUrlQuery",
      "operationKind": "query",
      "text": "query logoUploadUrlQuery {\n  logoUploadUrl\n}\n"
    }
  };
}();

node.hash = "53548301a63155a09530cd433f1b4319";
module.exports = node;